import { EditOutlined } from "@ant-design/icons";
import { Space, Table, Drawer, Button, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import tdsSectionService from "../../../api/tdssection.service";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE, GREEN_TAG, RED_TAG } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import TdsSectionEntry from "./TdsSectionEntry";
import CustomTableSearch from "../../common/CustomTableSearch";

const TdsSectionList = ({ refreshTrigger = 0 }) => {

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);

  const [visible, setVisible] = useState(false);
  const [filteredSearchList, setFilteredSearchList] = useState([]);
  const [tdsSectionList, setTdsSectionList] = useState([]);
  const [tdsSectionData, setTdsSectionData] = useState({
    tdsId: 0,
    tds_desc: '',
    tds_rate: '',
    is_active: 'Y',
    mode: EDIT_MODE
  });
  const [refreshList, setRefreshList] = useState(0);

  const showDrawer = (rowdata) => {
    tdsSectionService.tdsById(rowdata.tds_id).then((res) => {
      const tdsData = res.data.response_data;
      setTdsSectionData({
        tdsId: tdsData.tds_id,
        tds_desc: tdsData.tds_desc,
        tds_rate: tdsData.tds_rate,
        is_active: tdsData.is_active,
        mode: EDIT_MODE
      });
      setVisible(true);
    });
  };


  const onClose = () => {
    setVisible(false);
    setRefreshList(prev => prev + 1);
  };

  const onRefreshList = () => {
    setRefreshList(prev => prev + 1);
  };





  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      render: (text, record, index) => (page - 1) * 10 + ++index,
      width: '5%',
    },
    {
      title: 'TDS Description',
      dataIndex: 'tds_desc',
      key: 'tds_desc',
      sorter: (a, b) => a.tds_desc.localeCompare(b.tds_desc),
    },
    {
      title: 'TDS Rate (%)',
      dataIndex: 'tds_rate',
      key: 'tds_rate',
      sorter: (a, b) => parseFloat(a.tds_rate) - parseFloat(b.tds_rate),
      width: '15%',
      align: 'right'
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (selectedObj, record) => (
        <Space size="middle">
          {
            record.is_active == "Y" ? <><Tag color={GREEN_TAG}>Active</Tag></> : <><Tag color={RED_TAG}>Not Active</Tag></>
          }
        </Space>
      ),
      width: '15%',
      align: 'center',
    },
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        <Space size="middle">
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={() => showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
      width: '15%',
      align: 'center',
    },
  ];


  useEffect(() => {
    tdsSectionService.list().then((res) => {
      setTdsSectionList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [refreshList, refreshTrigger])


  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    const filtered_list = tdsSectionList.filter(data =>
      data.tds_desc.toLowerCase().indexOf(string.trim().toLowerCase()) !== -1 ||
      data.tds_rate.toString().indexOf(string.trim()) !== -1
    );
    setFilteredSearchList(filtered_list);
  }

  return (
    <>

      <CustomTableSearch onSearchTable={onSearch} />
      <Table columns={columns}
        rowKey='tdsId'
        dataSource={filteredSearchList}
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
      />

      <Drawer
        title="Edit TDS"
        width={DEFAULT_MASTER_DRAWER_WIDTH}
        onClose={onClose}
        visible={visible}
        bodyStyle={{
          paddingBottom: 80,
        }}
        destroyOnClose={true}
        closeIcon={<><DrawableCloseIcon /></>}
      >
        <TdsSectionEntry data={tdsSectionData} onDrawerClose={onClose} onRefreshList={onRefreshList} />
      </Drawer>

    </>
  );
}

export default TdsSectionList